const insertAtIndex = (
  original: string,
  insertValue: string,
  end: number,
  start = 0
) =>
  original.toString().substring(start, end) +
  insertValue +
  original.toString().substring(end)

const replaceUntilIndex = (
  original: string,
  insertValue: string,
  end: number
) => insertValue + original.toString().substring(end)

const getLastWord = (data: string) => {
  const wordArray = data.split(' ')
  return wordArray[wordArray.length - 1]
}

const getIdFromS3Key = (key: string | undefined): string => {
  return ((key || '').split('/').pop() || '').split('.')[0]
}

const firstCharToLowerCase = (original: string) =>
  original[0].toLowerCase() + original.slice(1)

const getFirstCharCapitalized = (original: string) =>
  original[0].toUpperCase() + original.slice(1)

const getFirstGroupedNumbersIfExist = (original: string) => {
  const separatedBySpaces = original.split(' ')
  return separatedBySpaces.find((charGroup) => charGroup.match(/\d+/))
}

const capitalizeEachFirstWord = (original: string) =>
  original
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
    .join(' ')

const capitalizeName = (original: string) =>
  original
    .toLowerCase()
    .replace(/[^-\\/'\s]+/gm, (word) =>
      word.replace(/^./, (firstChar) => firstChar.toUpperCase())
    )

const sanitizeName = (original: string): string =>
  original?.replace(/[0-9+()]/gm, '').trim()

export {
  insertAtIndex,
  getLastWord,
  getIdFromS3Key,
  replaceUntilIndex,
  firstCharToLowerCase,
  getFirstCharCapitalized,
  getFirstGroupedNumbersIfExist,
  capitalizeEachFirstWord,
  capitalizeName,
  sanitizeName
}
